import React, {useMemo, useState, useEffect} from 'react';

import FormControl from '@mui/material/FormControl';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import Grid from '@mui/material/Grid';

import InputLabel from '@mui/material/InputLabel';

import {useFormStore} from '../../../Stores/form';

import {useGlobalCustomContext} from '../../../Helpers/context'

export default function Partner(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props;

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => { setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const className = useMemo(() => {
        return 'PartnerInput'
        + (isDisabled ? ' disabled' : '')
        + (showErrorText ? ' error' : '')
    }, [isDisabled, showErrorText, field]);

    const {userState} = useGlobalCustomContext();

    const onValueChange = (e) => {
        const parts = e.target.value.split('---')
        const data = {partner: parts[1]}

        if (parts[0] === 'product') data.product = parts[2]

        onChange({target: {value: data}})
    }

    const placeholder = useMemo(() => field.required ? `${field.placeholder} *` : field.placeholder, [field]);

    if (!userState?.user?.partnership) return <div>{field?.placeholder}: дані відсутні</div>

    const selectedValue = (content[field.id]?.partner && content[field.id]?.product) ?
    `product---${content[field.id]?.partner}---${content[field.id]?.product}`
        : '';

    return (<Grid key={field?.id} item xs={12}>
        <FormControl disabled={isDisabled} error={Boolean(showErrorText)} fullWidth className={className}>
            <InputLabel error={Boolean(showErrorText)}>{placeholder}</InputLabel>
            <Select
                defaultValue=''
                value={selectedValue}
                onChange={onValueChange}
                onBlur={onBlur}
            >
                    {userState?.user?.partnership?.products?.map(product => <MenuItem key={`product---${product.partner}---${product.product}`} value={`product---${product.partner}---${product.product}`}>
                        {userState?.user?.partnership?._info[product.partner].title}: {product.title}
                    </MenuItem>)}
            </Select>
            {showErrorText && <div className="fieldError">{showErrorText}</div>}
        </FormControl>
    </Grid>)
}
